import React, { useState } from "react"
// import "./style.scss"
import UpgradePlanModal, { User, URLs } from "app/components/upgrade_plan_modal"

interface Props {
  illustrationPath: string
  urls: URLs
  user: User
}

const HolidayModal = ({ urls, user, illustrationPath }: Props) => {
  const [showModal, setShowModal] = useState(false)

  document.querySelector(".holiday-banner[data-pure=true]")?.remove()

  const signedInUser = !!window.App.user?.id
  const existingLink = document.head.querySelector(`link[rel='preload'][href='${illustrationPath}']`)
  if (!existingLink) {
    const link = document.createElement("link")
    link.rel = "preload"
    link.as = "image"
    link.href = illustrationPath
    document.head.appendChild(link)
  }

  const displayModal = () => {
    setShowModal(true)
    window.App.Utils?.logCustomDatadogAction?.("holiday_banner_click")
  }

  window.addEventListener(
    "load",
    () => {
      const url = new URL(window.location.href)
      if (url.searchParams.get("holiday") == "tech-the-halls") {
        window.App.Utils?.logCustomDatadogAction?.("holiday_checkout_modal_auto_preview")
        setShowModal(true)
      }
    },
    { once: true }
  )

  return (
    <>
      {signedInUser && (
        <UpgradePlanModal
          onClose={() => setShowModal(false)}
          onUpgrade={() => setShowModal(false)}
          proPlusProductId="pro-plus-annual"
          step="holiday"
          tierRequirement="holiday"
          user={user}
          visible={showModal}
          urls={urls}
        />
      )}
      <div className="holiday-banner" role="button" aria-label="Holiday banner" onClick={() => displayModal()}>
        Tech the halls with our best prices of the season. <span className="cta">Get 35% off Pro</span> 🎁
      </div>
    </>
  )
}

export default HolidayModal
